import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Tabs, Input, Table, Popconfirm } from 'antd';
import { ArrowLeftOutlined, SaveOutlined, DeleteOutlined, EditOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import TextFilter from '../components/TextFilter';

import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

import Profile from '../components/settings/Profile';
import Social from '../components/settings/Social';
import Security from '../components/settings/Security';
import PaymentGateway from '../components/settings/PaymentGateway';

function Setting() {
	const navigate = useNavigate();

	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	const [gridLoading, setGridLoading] = useState(true);
	const [gridData, setGridData] = useState([]);
	const [totalRecords, setTotalRecords] = useState(0);
	const [gridHeight, setGridHeight] = useState(window.innerWidth - 182);

	const get = (options = {}) => {
		if (!options.pagination) {
			options.pagination = { start: 0, limit: 20 };
		} else {
			options.pagination = {
				start: (options.pagination.current - 1) * options.pagination.pageSize,
				limit: options.pagination.pageSize,
			};
		}

		if (options.sorter && options.sorter.order) {
			options.sorter = {
				field: options.sorter.field,
				order: options.sorter.order,
			};
		} else {
			options.sorter = { field: '_id', order: 'desc' };
		}

		// if (options.filters) {
		//    options.filters = _.omitBy(options.filters, _.isNil);
		// }

		axios
			.get(`/setting`, { params: options })
			.then((result) => {
				setGridData(result.data.data);
				setTotalRecords(result.data.data.length);
			})
			.finally(() => {
				setGridLoading(false);
			});
	};

	const deleteRecord = (record) => {
		setGridLoading(true);
		axios
			.delete(`/setting`, { data: { _id: record._id } })
			.then((result) => {
				message.success(result.data.message);
				get();
			})
			.catch(() => {
				message.error('Oops! Something went wrong!');
			})
			.finally(() => {
				setGridLoading(false);
			});
	};

	const onTableChange = (pagination, filters, sorter) => {
		get({ pagination, filters, sorter });
	};

	useEffect(() => {
		get();
		window.onresize = () => {
			setGridHeight(window.innerWidth - 182);
		};
	}, []);

	return (
		<>
			<BreadCrumb
				breadcrumbs={[
					{
						link: '/',
						label: 'Home',
					},
					{
						label: 'Settings',
					},
				]}
			/>
			{/* <Spin spinning={isLoading}>
        <div className="main-content">
          <div className="page-header">
            <div className="page-title">Settings</div>
            <div className="page-title-more">
              <Link to="/setting">
                <Button icon={<ArrowLeftOutlined />}>Back</Button>
              </Link>
              <Button icon={<SaveOutlined />} type="primary">
                Save
              </Button>
            </div>
          </div>
          <div className="form-content">
            <Form form={form} layout="vertical" autoComplete="off">
              <Tabs
                defaultActiveKey="1"
                items={[
                  {
                    key: 'Profile',
                    label: 'Profile',

                    children: <Profile Form={Form} />,
                  },
                  {
                    key: 'Social',
                    label: 'Social',
                    children: <Social Form={Form} />,
                  },
                  {
                    key: 'Security',
                    label: 'Security',
                    children: <Security Form={Form} />,
                  },
                  {
                    key: 'Payment Gateway',
                    label: 'Payment Gateway',
                    children: <PaymentGateway Form={Form} />,
                  },
                ]}
              />
            </Form>
          </div>
        </div>
      </Spin> */}

			<div className='main-content'>
				<div className='page-header'>
					<div className='page-title'>Settings</div>
					<div className='page-title-more'>
						<Input.Search placeholder='Search' style={{ width: '140px' }} />
						<Link to='/setting/add'>
							<Button icon={<PlusCircleOutlined />} type='primary'>
								Add
							</Button>
						</Link>
					</div>
				</div>
				<div className='grid-content'>
					<Table
						tableLayout='fixed'
						bordered
						size='small'
						rowKey='_id'
						showSorterTooltip={false}
						loading={gridLoading}
						dataSource={gridData}
						scroll={{ x: 850, y: gridHeight }}
						onChange={onTableChange}
						pagination={{
							defaultPageSize: 20,
							showLessItems: true,
							showQuickJumper: true,
							showSizeChanger: true,
							pageSizeOptions: [20, 50, 100, 200],
							size: 'small',
							responsive: true,
							total: totalRecords,
							showTotal: (total) => `Total ${total} items`,
						}}
						columns={[
							{
								title: 'Action',
								key: 'action',
								align: 'center',
								fixed: 'left',
								width: 80,
								render: (text, record, index) => (
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-around',
											alignItems: 'center',
										}}
									>
										<Link to={`/profile/edit/${record._id}`}>
											<EditOutlined className='grid-edit-icon' />
										</Link>
										<Popconfirm
											title='Are you sure you want to delete this record?'
											okText='Yes'
											cancelText='No'
											size='small'
											placement='bottomLeft'
											onConfirm={() => {
												deleteRecord(record);
											}}
										>
											<DeleteOutlined style={{ fontSize: 14 }} />
										</Popconfirm>
									</div>
								),
							},
							{
								title: 'Title',
								dataIndex: 'title',
								sorter: true,
								ellipsis: true,
								width: 200,
								filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => <TextFilter />,
								filterIcon: <SearchOutlined />,
							},
							{
								title: 'Type',
								dataIndex: 'profileType',
								sorter: true,
								ellipsis: true,
								width: 170,
								filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => <TextFilter />,
								filterIcon: <SearchOutlined />,
							},
							{
								title: 'Username',
								dataIndex: 'username',
								sorter: true,
								ellipsis: true,
								width: 170,
							},
							{
								title: 'Account Status',
								dataIndex: 'accountstatus',
								sorter: true,
								ellipsis: true,
								width: 110,
							},
						]}
					/>
				</div>
			</div>
		</>
	);
}

export default Setting;
